<h6 class="fw-bold mt-3" i18n>Mein Name</h6>
<p class="text-muted small" i18n>
  Ihr eigener Name als angemeldeter Benutzer — unabhängig von den Kunden- bzw.
  Verkäuferdaten. Ein geleertes Feld „Mittelname“ entfernt diesen.
</p>
<form [formGroup]="nameForm">
  <div class="row">
    <div class="col-sm-6">
      <app-form-row label="Vorname" i18n-label>
        <input
          id="userFirstName"
          type="text"
          formControlName="firstName"
          class="form-control form-control-sm"
          />
      </app-form-row>
      <app-form-row label="Mittelname" i18n-label>
        <input
          id="userMiddleName"
          type="text"
          formControlName="middleName"
          class="form-control form-control-sm"
          />
      </app-form-row>
      <app-form-row label="Nachname" i18n-label>
        <input
          id="userLastName"
          type="text"
          formControlName="lastName"
          class="form-control form-control-sm"
          />
      </app-form-row>
      <button
        type="button"
        class="btn btn-primary"
        [asyncClick]="save(nameForm.value)"
        [disabled]="saveBtn.disabled || !nameForm.valid"
        #saveBtn="asyncClick"
        i18n
        >
        Speichern
      </button>
    </div>
  </div>
</form>
